// extracted by mini-css-extract-plugin
module.exports = {"container":"FiltersSector-container-n6hE_x","filterContainer":"FiltersSector-filterContainer-1JBR-5"};